import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { InvoiceService } from "src/app/_services/invoice.service";
import { formatDate, DatePipe } from "@angular/common";
import * as moment from "moment-timezone";

@Component({
    selector: "app-invoice-detail",
    templateUrl: "./invoice-detail.component.html",
    styleUrls: ["./invoice-detail.component.scss"],
})
export class InvoiceDetailComponent implements OnInit {
    po: any;
    responseData: any;
    isError: any;
    isEmpty = false;
    loading = true;
    displayName: any;
    invoice: any;
    utrExist = false;
    paymentDateExist = false;
    paymentAdviceExist = false;
    paymentDueDateExist = false;
    isCondensed = false;
    debitNoteExist = false;
    currentLayout = {
        isCondensed: true,
    };
    showing = false;
    showStatusInfo = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private datePipe: DatePipe,
        private invoiceService: InvoiceService
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    statusInfo() {
        this.showing = true;
        this.showStatusInfo = true;
    }

    closeStatusInfo() {
        this.showing = false;
        this.showStatusInfo = false;
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        const code = this.route.snapshot.params["barcode"];
        const userData = {
            barcode: this.route.snapshot.params["barcode"],
            action: "get",
            docTyp: "invoice",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.invoiceService.fecthInvoices(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;

                this.invoice = this.responseData.invoice[0];

                this.invoice.statuses.forEach((status) => {
                    if (
                        typeof status.creation_date_sys_iso !== "undefined" &&
                        status.creation_date_sys !== ""
                    ) {
                        const gmtMoment = moment(status.creation_date_sys_iso);
                        const istMoment = gmtMoment.tz("Asia/Kolkata"); // IST timezone

                        // Format the IST timestamp according to your desired format
                        status.creation_date_sys = istMoment.format(
                            "MMM DD, yyyy HH:mm a"
                        );
                    }

                    if (typeof status.status_reason === "undefined") {
                        this.invoice.status_reason = "";
                    }
                    // else if (
                    //     typeof status.status_update_date_iso !== "undefined" &&
                    //     status.creation_date_sys !== ""
                    // ) {
                    //     // status_update_date_iso
                    //     const date = new Date(status.status_update_date_iso);

                    //     // Adjust the date to IST by adding the offset
                    //     const istOffset = 330; // Offset in minutes for IST
                    //     const adjustedDate = new Date(
                    //         date.getTime() + istOffset * 60000
                    //     );
                    //     console.log(adjustedDate);
                    //     // status.creation_date_sys = this.datePipe.transform(
                    //     //     adjustedDate,
                    //     //     "EEE MMM dd HH:mm:ss 'IST' yyyy"
                    //     // );
                    // }
                });

                if (
                    this.checkObjectKeyExist(
                        this.invoice,
                        "rejections",
                        "rej1"
                    ) === undefined
                ) {
                    Object.assign(this.invoice, { rejection1: false });
                } else {
                    Object.assign(this.invoice, { rejection1: true });
                }

                if (
                    this.checkObjectKeyExist(
                        this.invoice,
                        "rejections",
                        "rej2"
                    ) === undefined
                ) {
                    Object.assign(this.invoice, { rejection2: false });
                } else {
                    Object.assign(this.invoice, { rejection2: true });
                }

                if (
                    this.checkObjectKeyExist(this.invoice, "gst_reconciled") ===
                    undefined
                ) {
                    Object.assign(this.invoice, { gst_exist: false });
                } else {
                    Object.assign(this.invoice, { gst_exist: true });
                }

                if (
                    typeof this.invoice.utr_number !== "undefined" &&
                    typeof this.invoice.utr_number &&
                    this.invoice.utr_number !== ""
                ) {
                    this.utrExist = true;
                }

                if (
                    typeof this.invoice.payment_date !== "undefined" &&
                    this.invoice.payment_date !== null &&
                    this.invoice.payment_date !== ""
                ) {
                    this.paymentDateExist = true;
                }

                if (
                    typeof this.invoice.payment_due_date !== "undefined" &&
                    this.invoice.payment_due_date !== null &&
                    this.invoice.payment_due_date !== ""
                ) {
                    this.paymentDueDateExist = true;
                }

                if (
                    typeof this.invoice.debit_note_attachment !== "undefined" &&
                    this.invoice.debit_note_attachment !== null &&
                    this.invoice.debit_note_attachment !== ""
                ) {
                    this.debitNoteExist = true;
                }

                if (
                    typeof this.invoice.payment_advice_attachment !==
                        "undefined" &&
                    this.invoice.payment_advice_attachment !== null &&
                    this.invoice.payment_advice_attachment !== ""
                ) {
                    this.paymentAdviceExist = true;
                }
            },
            (error) => {}
        );
    }

    checkObjectKeyExist(obj, ...args) {
        return args.reduce((obj, level) => obj && obj[level], obj);
    }

    // hasProp(obj: any, name: any) {
    //     return obj.hasOwnProperty(name);
    // }
}
